import React, { Component } from "react";
import EnergyManagePage from "./energyManagePage/energyManagePage";
import SelectGroupPage from "./selectGroupPage/selectGroupPage";
import EnergyHotPage from "./energyHotPage/energyHotPage";
import EnergyLogPage from "./energyLogPage/energyLogPage";
import EnergyBarChart from "./energyBarChart/energyBarChart";
import EnergyDeviceChart from "./energyDeviceChart/energyDeviceChart";
import DesignView from "../admin/designView/designView";
import { meshLog } from "../../utils/spUtils";
import pingmiantu8 from '../../imgs/bg/pingmiantu8.png';
import ceshitu from '../../imgs/bg/ceshitu.png';
import PubSub from 'pubsub-js'
import './energy.less';
import { ENERGY_Data_Img, ENERGY_Data_Log, ENERGY_show_group, ENERGY_show_hot, SPIN_DIALOG_HIDE } from "../../const/infoConst";

let mHot = 0;
export default class Energy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSelectGroupPage: 'hidden', //'visible'
      showHotPage: 'hidden', //'visible'
      multi: 0, //0-area  1-group  2-device  3-log
    };
  }

  componentDidMount() {
    PubSub.subscribe('goToEnergyBarChart2', (msg, data) => {
      //0-area  1-group  2-device
      this.setState({
        multi: 1,
      });
    })
  }

  getDataFromManage = (msg) => {
    //0-area  1-group  2-device  3-log
    this.setState({
      multi: -1, //隐藏，防UI闪烁
    })

    setTimeout(() => {
        // PubSub.publish(SPIN_DIALOG_HIDE, '');
        this.setState({
          multi: msg,
        })
    }, 100)    

  }

  //侧边栏显示
  getDataFromSelectGroup = (msg) => {
    this.setState({
      showSelectGroupPage: 'hidden',
    });
  }
  getDataFromHot = (msg) => {
    this.setState({
      showHotPage: 'hidden',
    });
  }

  render() {
    return (
      <div className="energy-container">
        {/* 左侧边栏 */}
        <div className="sidebar1"><EnergyManagePage onDataToParent={this.getDataFromManage} /></div>
        {/* 右侧平面图区域 */}
        <div className="content">
          <div className="logPage" style={{ display: this.state.multi == 2 ? "flex" : "none" }}><EnergyDeviceChart /></div>
          <div className="logPage" style={{ display: (this.state.multi == 0 || this.state.multi == 1) ? "flex" : "none" }}><EnergyBarChart /></div>
          <div className="logPage" style={{ display: this.state.multi == 3 ? "flex" : "none" }}><EnergyLogPage /></div>
          <div className="sidebar2" style={{ visibility: this.state.showSelectGroupPage, top: "150px", height: "500px" }}><SelectGroupPage onDataToParent={this.getDataFromSelectGroup} /></div>
          <div className="sidebar2" style={{ visibility: this.state.showHotPage, top: "300px", height: "500px" }}><EnergyHotPage onDataToParent={this.getDataFromHot} /></div>
        </div>
      </div>
    )
  }
}
